var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_8313)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#919B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6758 81.3521H75.4055V73.9197C75.4024 71.1609 74.3051 68.5161 72.3544 66.5654C70.4037 64.6147 67.7588 63.5174 65.0001 63.5142H56.0812C53.3225 63.5174 50.6776 64.6147 48.7269 66.5654C46.7762 68.5161 45.6789 71.1609 45.6758 73.9197V81.3521ZM50.1352 50.1359C50.1352 52.1939 50.7455 54.2056 51.8889 55.9168C53.0322 57.628 54.6573 58.9617 56.5587 59.7492C58.46 60.5368 60.5522 60.7428 62.5706 60.3413C64.5891 59.9398 66.4432 58.9488 67.8984 57.4936C69.3536 56.0384 70.3446 54.1843 70.7461 52.1659C71.1476 50.1474 70.9415 48.0552 70.154 46.1539C69.3664 44.2526 68.0327 42.6275 66.3216 41.4841C64.6104 40.3407 62.5986 39.7305 60.5406 39.7305C57.781 39.7305 55.1343 40.8267 53.1829 42.7781C51.2315 44.7295 50.1352 47.3762 50.1352 50.1359Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5421,
    y: 96.8109,
    width: 22.5946,
    height: 22.5946,
    rx: 11.2973,
    fill: "#FBA622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1616 108.061H94.5171",
    stroke: "#F6FAFB",
    strokeWidth: 2.02703
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8867 112.786V103.431",
    stroke: "#F6FAFB",
    strokeWidth: 2.02703
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5421,
    y: 96.8109,
    width: 22.5946,
    height: 22.5946,
    rx: 11.2973,
    stroke: "#FBA622",
    strokeWidth: 1.18919
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_8313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/Profiles.356d8c97c4d07fe29af4fd3ded5413a1.svg";
export { ForwardRef as ReactComponent };